export const CONTACT = {
  company: "SK Engineering Works",
  tagline: "Aluminium Pressure Die Casting & Precision Components",
  address: "Plot No-15 A, Lane No 14, Railway Road, SamayPur, Delhi 110042",
  phone1: "+91-9312264544",
  phone2: "+91-9871800544",
  whatsapp: "919312264544",
  email: "sanjaykakkar_12@yahoo.com",
};

export const PRODUCTS = [
  {
    id: "cav-single",
    name: "Cav Assembly Single",
    img: "/products/cav-assembly-single.png",
    tag: "Filter Assembly",
    desc: "Single-head cav filter assembly, pressure die cast in aluminium with machined threaded ports and a cast mounting flange.",
  },
  {
    id: "water-separator",
    name: "Water Separator Inter / Power Trac / Ford",
    img: "/products/water-separator.png",
    tag: "Automotive",
    desc: "Water separator body developed for Inter, Power Trac and Ford applications, cast with integrated mounting flange and directional flow ports.",
  },
  {
    id: "single-big",
    name: "Single Assembly Big 1.1 Ltr",
    img: "/products/single-assembly-big.png",
    tag: "Filter Assembly",
    desc: "Large 1.1 litre single assembly head, die cast for consistent wall thickness, dimensional accuracy and reduced machining.",
  },
  {
    id: "cav-double",
    name: "Cav Assembly Double",
    img: "/products/cav-assembly-double.png",
    tag: "Filter Assembly",
    desc: "Twin-head cav assembly casting with integrated ports and fixing lugs, cast in one piece for strength and reliability.",
  },
  {
    id: "candle-stand",
    name: "Five-Arm Candle Stand in PDC",
    img: "/products/five-arm-candle-stand.png",
    tag: "Decorative / Handicraft",
    desc: "Five-arm candle stand pressure die cast in aluminium — decorative components with fine surface finish, supplied raw or finished.",
  },
  {
    id: "cricket-statue",
    name: "Cricket Statue in Aluminium PDC",
    img: "/products/cricket-statue.jpg",
    tag: "Decorative / Handicraft",
    desc: "Cricket batsman statue pressure die cast in aluminium — available raw or with a polished finish, ideal for trophies, souvenirs and gifting.",
  },
  {
    id: "single-arm-candle-stand",
    name: "Single Arm Candle Stand",
    img: "/products/single-arm-candle-stand.jpg",
    tag: "Decorative / Handicraft",
    desc: "Classic single-arm candle stand die cast in aluminium, offered in multiple heights with a fine polished finish.",
  },
  {
    id: "three-arm-candle-stand",
    name: "Three Arm Aluminium Candle Stand in PDC",
    img: "/products/three-arm-candle-stand.jpg",
    tag: "Decorative / Handicraft",
    desc: "Elegant three-arm candelabra pressure die cast in aluminium, with fine detailing and a premium finish.",
  },
  {
    id: "aluminium-base",
    name: "Aluminium Base",
    img: "/products/aluminium-base.jpg",
    tag: "Decorative / Handicraft",
    desc: "Ornately detailed aluminium base casting with scalloped edges and relief artwork — supplied raw or finished as required.",
  },
  {
    id: "diesel-1ltr",
    name: "Diesel Filter Assembly 1 Ltr",
    img: "/products/diesel-1ltr.jpg",
    tag: "Filter Assembly",
    desc: "Twin-canister diesel filter assembly head, pressure die cast in aluminium with machined ports, bolts and mounting holes.",
  },
  {
    id: "diesel-half-ltr",
    name: "Diesel Filter Assembly 1/2 Ltr",
    img: "/products/diesel-half-ltr.jpg",
    tag: "Filter Assembly",
    desc: "Compact 1/2 litre twin-bowl diesel filter assembly casting, developed as per drawing with integrated mounting flange and threaded ports.",
  },
  {
    id: "snowflake",
    name: "Aluminum bracket in Pdc raw casting",
    img: "/products/snowflake.jpg",
    tag: "Decorative / Handicraft",
    desc: "Aluminium bracket pressure die cast with ornate detailing — supplied as raw casting or finished as per requirement.",
  },
];

export const PRODUCT_OPTIONS = [
  ...PRODUCTS.filter((p) => !p.imageOnly).map((p) => p.name),
  "Custom Component (Drawing / Sample)",
  "General Enquiry",
];

export const WHAT_WE_MAKE = [
  "Aluminium motor components",
  "Engineering components",
  "Cav assemblies",
  "Filter assemblies",
  "Electrical and industrial components",
  "Aluminium housings and covers",
  "Customised pressure die-cast components",
  "Decorative and handicraft components",
  "Components developed as per customer drawings or samples",
];

export const PROCESS_STEPS = [
  {
    title: "Customer Drawing / Sample",
    desc: "We study the customer's drawing, sample or technical requirements and evaluate the component for die-casting feasibility.",
  },
  {
    title: "Product Development & Die Planning",
    desc: "The component is reviewed for suitable parting line, wall thickness, draft angles, gating, runner and overflow requirements. Die and tooling requirements are finalised before production.",
  },
  {
    title: "Die Manufacturing",
    desc: "Required dies and tooling are developed according to the approved component design and production requirements.",
  },
  {
    title: "Aluminium Melting",
    desc: "Aluminium alloy ingots and approved raw material are melted in the melting furnace under controlled operating conditions.",
  },
  {
    title: "Aluminium Pressure Die Casting",
    desc: "The molten aluminium is transferred to the pressure die-casting machine and injected into the die under controlled pressure and speed.",
    chips: [
      "Good dimensional consistency",
      "Complex shapes",
      "Fine surface finish",
      "Reduced machining requirements",
      "High production efficiency",
    ],
  },
  {
    title: "Trimming & Fettling",
    desc: "After casting, excess material such as runners, gates and flash is removed. Components are then fettled and visually inspected.",
  },
  {
    title: "Machining",
    desc: "Where required, cast components undergo secondary machining operations such as drilling, tapping, boring, milling and other required processes.",
  },
  {
    title: "Finishing",
    desc: "Components can be supplied with the required finishing operations depending on customer specifications.",
  },
  {
    title: "Inspection & Quality Control",
    desc: "Components are inspected for dimensional accuracy, appearance and other specified requirements before dispatch.",
  },
  {
    title: "Assembly & Final Dispatch",
    desc: "Where required, we undertake component assembly and supply finished or semi-finished products ready for the customer's production line.",
  },
];

export const MACHINERY = [
  { icon: "factory", title: "Aluminium Pressure Die Casting Machines", featured: true },
  { icon: "flame", title: "Melting Furnaces" },
  { icon: "layers", title: "Gravity Casting Facilities" },
  { icon: "scissors", title: "Trimming / Fettling Equipment" },
  { icon: "disc", title: "CNC Turning Machines" },
  { icon: "drill", title: "Drilling Machines" },
  { icon: "tap", title: "Tapping Machines" },
  { icon: "mill", title: "Milling Machines" },
  { icon: "wrench", title: "Machining Equipment" },
  { icon: "sparkles", title: "Grinding / Finishing Equipment" },
  { icon: "package", title: "Assembly Facilities" },
  { icon: "ruler", title: "Inspection & Measuring Equipment", wide: true },
];

export const WHY_US = [
  {
    title: "Complete Component Development",
    desc: "From drawing/sample evaluation to production and finishing.",
  },
  {
    title: "Aluminium Pressure Die Casting Expertise",
    desc: "Specialised manufacturing capability for aluminium die-cast components.",
  },
  {
    title: "Customised Product Development",
    desc: "Components can be developed according to customer drawings, samples and requirements.",
  },
  {
    title: "Integrated Manufacturing",
    desc: "Die casting, trimming, machining, finishing and assembly capabilities.",
  },
  {
    title: "Flexible Production",
    desc: "Suitable for both product development and regular production requirements.",
  },
  {
    title: "Quality-Focused Manufacturing",
    desc: "Inspection and process controls are incorporated throughout production.",
  },
];

export const INDUSTRIES = [
  "Automotive & Motor Components",
  "Electrical & Electronics",
  "Industrial Equipment",
  "Engineering Products",
  "Pumps & Machinery",
  "Consumer Products",
  "Railway Components",
  "Defence & Aerospace-related Engineering Applications",
  "Handicrafts & Decorative Products",
];

export const MARQUEE_ITEMS = [
  "Aluminium Pressure Die Casting",
  "50 g – 800 g Component Range",
  "Custom Die Development",
  "Precision Machining",
  "Assembly & Finishing",
  "SamayPur, Delhi, India",
];
